import React from "react";

// Front-end only PDF comparer (upload two PDFs, no backend).
const PdfComparer = React.lazy(() => import("./index"));

export default [
  {
    path: "/drawing_office/pdf_comparer",
    exact: true,
    name: "PDF Comparer",
    component: PdfComparer,
  },
];
